import { TimetableItemBase } from "./timetableItemBase";
import { TimetableCourse } from "./timetableCourse";
import { groupClassNames } from "./util";
import { TimetableSubstitution } from "./timetableSubstitution";
import { ModalShowTimetableItem } from "./modals/modalShowTimetableItem";

export class TimetableLessonGroup extends TimetableItemBase {

   constructor(course, view, mode, user, dm) {
      super(course);
      this.view = view;
      this.dm = dm;
      this.mode = mode;
      this.user = user;
      this.courses = [course];
      this.onCourseClick = (course) => {};
   }

   clone() {
 
      const clone = new TimetableLessonGroup({
         hour: this.hour,
         span: this.span,
         weekday: this.weekday
      }, this.view, this.mode, this.user, this.dm);

      clone.courses = this.courses.map(c => c.clone());
      clone.hours = this.hours.slice();

      return clone;

   }

   onClick(e) {
      new ModalShowTimetableItem(this, this.view, this.user, this.dm);
      e.stopPropagation();
   }


   /**
    * Versucht, der TimetableLessonGroup die Übergebene Vertretungsstunde in den übergebenen Stunden hinzuzufügen.
    * Gibt das Ergebnis zurück.
    * Das Ergebnis ist ein Objekt mit folgenden Attributen:
    *    hours: die Unterrichtsstunden der Vertretung, die nicht zugeordnet werden konnten
    *    addGroups: zusätzlich angelegte TimetableLessonGroups. Diese müssen angelegt werden, wenn eine TimetableLessonGroup
    *              gesplittet werden musste, weil eine Vertretung nur einen Teil dieser Gruppe belegt.
    * 
    * @param {*} subst
    * @param {*} hours
    * @returns 
    */
   apply(subst, hours) {

      let addGroups = [];

      if (this.weekday !== subst.weekday) return { hours, addGroups };

      const hourIntersection = this.hours.intersection(hours);

      // Wenn keine Übereinstimmung besteht: abbrechen
      if (hourIntersection.length === 0) return { hours, addGroups };

      // wenn kein Kurs gefunden wird, der die Stunde hinzugefügt werden kann: abbrechen und 'false' zurückgeben
      //if (!this.applyable(subst)) return { hours: [], addGroups};

      // Wenn die Vertretung nicht die komplette Gruppe ausfüllt:
      // -> Gruppe aufteilen
      if (hourIntersection.length !== this.hours.length) {
         addGroups = this.splitByHourIntersection(hourIntersection);
      }

      this.addSubstitution(subst);

      // Stunden, die untergebracht wurden, aus hours entfernen
      hours = hours.filter(h => !hourIntersection.includes(h));

      return { hours, addGroups };

   }

   /**
    * Gibt zurück, ob die Vertretung im Stundenplan angezeigt werden soll. Bei SuS der MSS sollen nur Vertretungen der eigenen
    * Kurse angezeigt werden.
    * @param { } subst 
    * @returns 
    */
   /*
   applyable(subst) {
      for (const course of this.courses) {
         if (this.view.type === 'pupil' && this.view.class.year >= 10) {
            const affectedTitles = subst.titles.concat(subst.absentTitles);
            return affectedTitles.hasIntersectionWith(course.titles);
         }
         else {
            return true;
         }
      }

      return false;

   }
   */

   render(elTable, gridPositions, dm) {

      const elCell = elTable.createElement('div', 'timetable-cell timetable-item');

      if (this.span === 0) return [];

      elCell.setStyles({
         gridArea: `${gridPositions.hour[this.hour-1]} / ${gridPositions.weekday[this.weekday-1]} / span ${this.span}`
      });

      for (let i=0; i<this.span; ++i) {
         elCell.classList.add('sel-' + this.weekday + '-' + (this.hour+i));
      }

      for (const course of this.courses) {
         const elCourse = elCell.createElement('div', 'timetable-course');
         course.onClick = this.onCourseClick;
         course.render(elCourse, this.view, dm);
      }

      elCell.onclick = (e) => this.onClick(e);

      return elCell;

   }


   /**
    * Teilt einen Kurs auf 
    */
   splitByHourIntersection(hourIntersection) {

      const newHourGroups = this.hours.splitByIntersection(hourIntersection);

      // Den aktuellen Kurs auf die gemeinsamen Stunden kürzen
      this.setHours(hourIntersection);

      // Kopien des aktuellen Kurses mit den übrigbleibenden Stunden anlegen
      const newGroups = newHourGroups.map(hourGroup => {
         const newGroup = this.clone();
         newGroup.setHours(hourGroup);
         return newGroup;
      });

      return newGroups;

   }

   setHours(hours) {
      super.setHours(hours);
      this.courses.map(c => c.setHours(hours));
   }

   /**
    * Ordnet einer Gruppe eine Vertretung zu.
    * Dabei wird zuerst versucht, den Kurs einem bereits vorhandenen Kurs hinzuzufügen (wenn es derselbe ist);
    * Gelingt dies nicht, wird ein neuer Kurs angelegt.
    * @param {*} course 
    */
   addSubstitution(subst) {

      for (const c of this.courses) {
         
         if (c instanceof TimetableSubstitution) continue;

         if (subst.belongsTo(c)) {
            c.addSubstitution(subst);
            return;
         }
      }

      this.courses.push(subst);

   }

   addCourse(course) {
      this.courses.push(course);
   }

   fits(hours) {
      for (let i=this.hour; i<this.hour+this.span; ++i) {
         if (!hours.includes(i)) return false;
      }
      return true;
   }

   applyToCourse(subst) {

      // alle Kurse durchgehen und dem Kurs zuordnen, wenn die lessonRef stimmt
      return false;

   }










}